import { inputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  inputAnatomy.keys,
);

const baseStyle = definePartsStyle({
  field: {
    fontSize: '15px',
    height: '40px',
    borderRadius: '0px',
    lineHeight: '40px',
  },
});

const variants = {
  outline: definePartsStyle({
    field: {
      background: 'white',
      borderWidth: '1px',
      borderRadius: '3px',
      borderColor: 'black',
      _placeholder: {
        color: 'black',
      },
      _focus: {
        borderColor: 'black',
        boxShadow: 'none',
      },
      _hover: {
        borderColor: 'black',
      },
    },
  }),
};

export const inputTheme = defineMultiStyleConfig({ baseStyle, variants });
